import styled from "styled-components";

import LoadingAnimation from "components/organisms/LoadingAnimation";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { Table } from "components/organisms/Table";
import { useGetSubscriptionStatisticsQuery } from "pages/Features/Statistikk/StatisticsPage.graphql-gen";

import { NotificationType } from "generated/graphql-types";

type SubscriptionStat = {
	type?: NotificationType;
	totalCount: number;
	uniqueUsers: number;
};

export function notificationTypeToName(t?: NotificationType) {
	switch (t) {
		case NotificationType.FORBRUKSTOPP:
			return "Forbrukstopp";
		case NotificationType.SPOTPRICE:
			return "Spotpris";
		case NotificationType.REALTIME_CONSUMPTION:
			return "Fjutt";
		case NotificationType.WEEKREPORT:
			return "Ukesrapport";
	}
}

export function StatisticsPage() {
	const { data, loading } = useGetSubscriptionStatisticsQuery();

	if (loading) return <LoadingAnimation />;

	return (
		<div>
			<MainLayoutPageHeader title={"Statistikk"} />
			<SectionTitle>Varslingsabonnenter</SectionTitle>
			<Table
				entries={data?.subscriptionStatistics as SubscriptionStat[]}
				labels={{ type: "Type", totalCount: "Antall", uniqueUsers: "Unike brukere" }}
				generators={{
					type: (t: SubscriptionStat) => <>{notificationTypeToName(t.type)}</>,
				}}
			/>
			<FooterNote>Det kan fylles på med ny statistikk her om ønskelig.</FooterNote>
		</div>
	);
}

export const SectionTitle = styled.h2`
	font-size: 20px;
	font-weight: 600;
	margin: 40px auto 20px;
`;

const FooterNote = styled.p`
	font-size: 0.875rem;
	color: var(--nte-graa-uu);
	margin-top: 40px;
`;
